(function () {
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem('motonum_wishlist') || '[]');
    } catch (e) {
      return [];
    }
  }

  function setWishlist(list) {
    try {
      localStorage.setItem('motonum_wishlist', JSON.stringify(list));
    } catch (e) {}
  }

  function refreshButton(btn) {
    var id = btn.getAttribute('data-product-id');
    var list = getWishlist();
    if (list.indexOf(id) !== -1) {
      btn.classList.add('is-active');
    } else {
      btn.classList.remove('is-active');
    }
  }

  function init() {
    var buttons = document.querySelectorAll('[data-motonum-wishlist]');
    buttons.forEach(function (btn) {
      refreshButton(btn);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = btn.getAttribute('data-product-id');
        var list = getWishlist();
        var idx = list.indexOf(id);
        if (idx === -1) {
          list.push(id);
        } else {
          list.splice(idx, 1);
        }
        setWishlist(list);
        refreshButton(btn);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
